import KebijakanVendor from './../views/kebijakanvendor/KebijakanVendor.vue'

const kebijakanVendor = [
  {
    path: '/setup-kebijakan-vendor',
    component: KebijakanVendor,
    meta: { auth: true }    
  }
]

export default kebijakanVendor